export var EStoreVariants = /* @__PURE__ */ ((EStoreVariants2) => {
  EStoreVariants2["GOOGLE_PLAY"] = "googleplay";
  EStoreVariants2["APP_STORE"] = "appstore";
  return EStoreVariants2;
})(EStoreVariants || {});
